module.exports = __webpack_public_path__ + "img/rebuild_huang_pc2.747a67ec.jpg";